import { actions, actionTypes, selectors } from 'data'
import { TradesMessageType } from 'data/types'
import { call, delay, put, select, takeEvery } from 'redux-saga/effects'
import { getRecent } from 'services/api/trades'
import webSocket from 'services/api/webSocket'
import { logger, sanitizeMessage } from 'utils'

import { TradeType } from './types'

const messageManager = function* (action) {
  const message: TradesMessageType = action.payload

  if (message.event === webSocket.event.REJECTED) {
    logger.warn(message?.text)
    return
  }

  if (message.event === webSocket.event.UPDATED) {
    yield put(actions.trades.setUpdate(sanitizeMessage(message) as TradeType))
    return
  }

  if (message.event === webSocket.event.SUBSCRIBED) {
    yield put(actions.trades.setSubscribed())
  }
}

const fetchRecentTrades = function* () {
  yield put(actions.trades.reset())
  const index = yield select(selectors.instrument.getInstrumentId)
  if (!index) return
  const data = yield call(getRecent, index)

  if (data.response) {
    // Delay to make sure there will be no duplicates arriving through WS
    // After recent trades insertion
    yield delay(300)
    yield put(actions.trades.setRecentTrades(data.response))
  }
}

export default function* tradesMain() {
  const channel = webSocket.channel.TRADES
  yield takeEvery(
    (action) => action.type === actionTypes.socket.RECEIVED && action.payload.channel === channel,
    messageManager
  )
  // Call fetch trades API on every subscription o trades
  yield takeEvery(
    (action) => action.type === actionTypes.socket.SUBSCRIBE && action.payload.channel === channel,
    fetchRecentTrades
  )
}
